let currentPage = 1; // Track the current page globally
let totalPages = 1;
function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}
function fetchProducts(activePage) {
  document.getElementById("loader").style.display = "flex";
  const searchQuery = document.getElementById("search").value;
  const page = activePage ?? 1;
  const selectedCategory = document.querySelectorAll(
    'input[type="checkbox"]:checked'
  );
  const categoryValues = Array.from(selectedCategory)
    .map((category) => category.value)
    .join(",");
  var currentURL = window.location.pathname;
  var urlSegments = currentURL.split("/");
  var desiredSegment = urlSegments[urlSegments.length - 1];
  const apiUrl = `https://shopmate.mcgrocer.com/api/v1/products?vendor__slug=${desiredSegment}&category__slug__in=${categoryValues}&search=${searchQuery}&page=${page}`;
  fetch(apiUrl)
    .then((response) => {
      if (!response.ok) {
        // Check for 502 Bad Gateway specifically
        if (response.status === 502) {
          throw new Error("Bad Gateway (502)");
        }
        // Handle other non-502 errors
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      totalPages = Math.ceil(data.count / 20);
      generateEllipsisPagination(1, totalPages);
      const categories = document.getElementById("vendor_categories");
      const productList = document.getElementById("product_list");
      productList.innerHTML = "";
        console.log('here');
        let count = 0; // Counter variable
        categories.innerHTML = "";
        data.results.category.forEach((item) => {
            if (count < 30) {
                categories.innerHTML += `<li>
                    <input type="checkbox" value="${item.slug}" class="categoryCheckbox">
                    <span class="category-name">${item.name}</span>
                    <span class="count">${item.count}</span>
                  </li>`;
                count++; // Increment the counter after processing each item
            }
        });
      data.results.products.forEach((item) => {
        productList.innerHTML += `
        <div class="col-md-2">
          <a href="/products/${item.slug}">
            <img src="${item.product_image_urls}" alt="${item.title}" class="product-image">
            <h3>${item.title}</h3>
            <img src="/cdn/shop/files/rating.png" class="ratingImg" alt="rating">
            <span class="price">£${item.selling_price}</span>
          </a>
          <div class="card-action">
             <form action="/cart/add" method="post" class="variants" data-product-id="${item.product_id}" enctype="multipart/form-data">
                <input type="hidden" name="id" value="${item.variantIds[0]}">
                <div class="cus-btn">
                   <div class="quantity-selector">
                      <input type="button" value="-" class="quantity-decrease">
                      <input type="number" min="1" value="1" name="quantity" class="quantity-input">
                      <input type="button" value="+" class="quantity-increase">
                   </div>
                   <button type="submit" name="add" data-btn-addtocart="" data-available="" class="product-form__submit button--primary an-" id="product-add-to-cart">Add to cart
                   </button>
                </div>
             </form>
          </div>
        </div>
        `;
      });
      window.scrollTo({
        top: 0,
        behavior: "smooth", // Use 'auto' or 'instant' for immediate scroll
      });
      document.getElementById("filterBtn").click();
      delayFunction();
      document.getElementById(
        "vendor_name"
      ).innerText = `${data.results.seller_info.display_name}`;
      document.getElementById(
        "vendor_description"
      ).innerText = `${data.results.seller_info.description === '' ? "There is no description for this vendor.": data.results.seller_info.description }`;
      document.getElementById(
        "vendor_logo"
      ).src = `${data.results.seller_info.image}`;
      document.getElementById("loader").style.display = "none";
    })
    .catch((error) => {
      console.error("Fetch error:", error.message);
       document.getElementById("loader").style.display = "none";
    });
}
//fetchProducts();

function fetchProductsByShopify(page_info=null,collection_id='') {
  document.getElementById("loader").style.display = "flex";
  var page_detail='';
  var collectionid='';
  if(page_info!=null)
  {
    page_detail='&page_info=' + page_info;
  }
  if(collection_id!='')
  {
    collectionid='&collectionId=' + collection_id;
  }
  var vendor_name=getUrlVars()['vendor_name'];
  var vendor_desc=getUrlVars()['vendor_desc'];
  var vendor_image=getUrlVars()['vendor_image'];
  //const apiUrl = `https://shopmate.mcgrocer.com/api/v1/products?vendor__slug=${desiredSegment}&category__slug__in=${categoryValues}&search=${searchQuery}&page=${page}`;
  const apiUrl = `https://phpstack-1400604-5298933.cloudwaysapps.com/shopify-products?vendor_name=${vendor_name}${page_detail}${collectionid}`;
  fetch(apiUrl)
    .then((response) => {
      if (!response.ok) {
        // Check for 502 Bad Gateway specifically
        if (response.status === 502) {
          throw new Error("Bad Gateway (502)");
        }
        // Handle other non-502 errors
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      const productList = document.getElementById("product_list");
       const pagination = document.getElementById("pagination-container");
      productList.innerHTML = "";
      pagination.innerHTML="";
      data.data.forEach((item) => {
         var product_image='';
        if(item.image!=null)
        {
          console.log('here');
          console.log(item.image);
          product_image=item.image.src;
        }
        productList.innerHTML += `
        <div class="col-md-3">
          <a href="/products/${item.handle}">
          <div class="product-image_outer">
            <img src="${product_image}" alt="${item.title}" class="product-image">
            <div class="card-action">
             <form action="/cart/add" method="post" class="variants" data-product-id="${item.id}" enctype="multipart/form-data">
                <input type="hidden" name="id" value="${item.variants[0].id}">
                <div class="cus-btn">
                   <!--div class="quantity-selector">
                      <input type="button" value="-" class="quantity-decrease">
                      <input type="number" min="1" value="1" name="quantity" class="quantity-input">
                      <input type="button" value="+" class="quantity-increase">
                   </div-->
                   <button type="submit" name="add" data-btn-addtocart="" data-available="" class="product-form__submit button--primary an-" id="product-add-to-cart"><svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.25835 9.81623V0.441228H5.84925V9.81623H4.25835ZM0.3663 5.92418V4.33327H9.7413V5.92418H0.3663Z" fill="white"></path>
                </svg>
                   </button>
                </div>
             </form>
          </div>
            </div>
            <h3>${item.title}</h3>
            <img src="/cdn/shop/files/rating.png" class="ratingImg" alt="rating">
            <span class="price">£${item.variants[0].price}</span>
          </a>
          
        </div>
        `;
       
      });
      document.getElementById("loader").style.display = "none";
     
      var prev_page = null;




if(data.prevPageInfo!=null)
{
   pagination.innerHTML += `
        <li data-page_info="${data.prevPageInfo}" class="pagination button-ATC-new"><img src="https://cdn.shopify.com/s/files/1/0522/0125/9183/files/left.png?v=1743070648"/> Prev</li>
    `;
}
      else
{
  pagination.innerHTML += `
        <li class="button-ATC-new" style="opacity: 0.5;cursor: none;"> Prev </li>
    `;
}
   if(data.nextPageInfo!=null)
{
   pagination.innerHTML += `
            <li  data-page_info="${data.nextPageInfo}" class="pagination button-ATC-new">Next <img src="https://cdn.shopify.com/s/files/1/0522/0125/9183/files/fast-forward-double-right-arrows-symbol.png?v=1743070471"></li>
        `;
}
      window.scrollTo({
        top: 0,
        behavior: "smooth", // Use 'auto' or 'instant' for immediate scroll
      });
      
      
    })
    .catch((error) => {
      console.error("Fetch error:", error.message);
    });
}
//fetchProducts();
fetchProductsByShopify();

function handleSearch(event) {
  event.preventDefault();
  fetchProducts();
}
var search = document.getElementById("searchForm");
search.addEventListener("submit", handleSearch);

function handleCheckboxChange() {
  fetchProducts();
}

function delayFunction() {
  const checkboxChange = document.querySelectorAll(".categoryCheckbox");
  checkboxChange.forEach((checkbox) => {
    checkbox.addEventListener("change", handleCheckboxChange);
  });
}

var ele = document.getElementById("filterBtn");
var toggle = document.getElementById("mobile-filters");
ele.addEventListener("click", function () {
  toggle.classList.toggle("expandHeight");
});


// Function to generate ellipsis pagination
function generateEllipsisPagination(currentPage, totalPages) {
  const paginationElement = document.getElementById("pagination-container");
  paginationElement.innerHTML = "";

  const visiblePages = 7; // Adjust this number based on your design

  // Calculate the range of visible pages
  const startPage = Math.max(1, currentPage - Math.floor(visiblePages / 2));
  const endPage = Math.min(totalPages, startPage + visiblePages - 1);

  // Add previous button
  paginationElement.appendChild(createPaginationItem("Prev", currentPage - 1));

  // Add ellipsis if needed before the first page
  if (startPage > 1) {
    paginationElement.appendChild(createEllipsis());
  }

  // Add page numbers
  for (let i = startPage; i <= endPage; i++) {
    paginationElement.appendChild(createPaginationItem(i));
  }

  // Add ellipsis if needed after the last page
  if (endPage < totalPages) {
    paginationElement.appendChild(createEllipsis());
  }

  // Add next button
  paginationElement.appendChild(createPaginationItem("Next", currentPage + 1));

  // Update the active class for the current page
  updateActiveClass();
}

// Helper function to create pagination item
function createPaginationItem(page) {
  const li = document.createElement("li");
  li.textContent = page === "Prev" ? "Prev" : page === "Next" ? "Next" : page;
  li.addEventListener("click", () => {
    // Handle click on pagination item
    if (page === "Prev" && currentPage > 1) {
      currentPage--;
    } else if (page === "Next" && currentPage < totalPages) {
      currentPage++;
    } else if (typeof page === "number") {
      currentPage = page;
    }
    console.log(`Clicked on page ${currentPage}`);
    generateEllipsisPagination(currentPage, totalPages);
    fetchProducts(currentPage);
  });
  return li;
}

// Helper function to create ellipsis
function createEllipsis() {
  const li = document.createElement("li");
  li.textContent = "...";
  li.classList.add("ellipsis");
  return li;
}

// Helper function to update the active class
function updateActiveClass() {
  const items = document.querySelectorAll("#pagination-container li");
  items.forEach((item) => {
    if (item.textContent === currentPage.toString()) {
      item.classList.add("active");
    } else {
      item.classList.remove("active");
    }
  });
}

jQuery(document).ready(function(){
  jQuery(document).on('click','#pagination-container .pagination',function(){
    var page_info=$(this).data('page_info');
     var page_collection=$(this).data('page_collection');
    fetchProductsByShopify(page_info,page_collection);
  });
  // jQuery(document).on('click','#pagination-container .pagination',function(){
  //  var page=$(this).data('page');
  //   var page_info=$(this).data('page_info');
  //   var page_collection=$(this).data('page_collection');
  //      fetchProductsByShopify(page,page_info,page_collection);
  // });
  jQuery(document).on('click','.categoryCheckbox.new',function(){
    if (jQuery(this).is(":checked")) {
            fetchProductsByShopify(null,$(this).val());
        } else {
            fetchProductsByShopify(null);
        }
   });
 
});